import { render, staticRenderFns } from "./indexFwbz.vue?vue&type=template&id=46ddbd20&scoped=true"
import script from "./indexFwbz.vue?vue&type=script&lang=ts"
export * from "./indexFwbz.vue?vue&type=script&lang=ts"
import style0 from "./indexFwbz.vue?vue&type=style&index=0&id=46ddbd20&prod&lang=scss&scoped=true"
import style1 from "./indexFwbz.vue?vue&type=style&index=1&id=46ddbd20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddbd20",
  null
  
)

export default component.exports